import { useEffect, type ReactNode } from "react";

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  width?: "narrow" | "normal" | "wide";
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  bodyless?: boolean;
};

export function Dialog({
  title,
  subtitle,
  width = "normal",
  onClose,
  children,
  footer,
  bodyless,
}: Props) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);

    // sinon la page défile derrière la fenêtre, et on perd sa position en fermant
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = overflow;
    };
  }, [onClose]);

  const sizes = { narrow: " is-narrow", normal: "", wide: " is-wide" };

  return (
    <div className="overlay" role="dialog" aria-modal="true" onMouseDown={onClose}>
      <div
        className={`sheet${sizes[width]}`}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="sheet-head">
          <div>
            <h2 className="sheet-title">{title}</h2>
            {subtitle && <p className="sheet-sub">{subtitle}</p>}
          </div>
          <button type="button" className="sheet-close" onClick={onClose} aria-label="Fermer">
            ✕
          </button>
        </header>

        {bodyless ? children : <div className="sheet-body">{children}</div>}

        {footer && <footer className="sheet-foot">{footer}</footer>}
      </div>
    </div>
  );
}
